import { style } from '@vanilla-extract/css';

export const subscriberBreakContainer = style({
  width: '100%',
  height: 'auto',
  maxWidth: '42rem',
  margin: '0 auto 2.5rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '2.5rem 2.5rem',
  backgroundColor: 'var(--wt-text-on-background-color, var(--site-theme-text-on-background-color, #000000))',
  color: 'var(--wt-background-color, var(--site-theme-background-color, #ffffff))',
});

export const subscriberBreakTextColor = style({
  color: 'var(--wt-background-color, var(--site-theme-background-color, inherit))',
});
